<template>
    <v-container>
        <v-card v-if="!users">
            <v-card-title v-if="org" class="display-1 font-weight-light">
                <v-spacer></v-spacer>
                <v-btn class="" icon @click="save()" v-if="dirty" color="primary">
                    <v-icon large>
                        {{icons.savealt}}
                    </v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text v-if="!appdata">
                <h3>Fetch Data</h3>
                <v-progress-linear indeterminate ></v-progress-linear>
            </v-card-text>
            <v-card-text v-else>
                <v-form ref="form" v-model="validinfo" v-if="social">
                    <v-row>
                        <v-col cols="12" sm="10" md="4" v-for="s in socialnetworks" :key="s.type" class="text-capitalize">
                            <v-text-field
                                    dense
                                    :label="s.type"
                                    v-model="social[s.type]"
                                    clearable
                                    outlined
                                    @keyup="setChange()"
                                    @focusout="setChange()"
                            ></v-text-field>

                        </v-col>
                    </v-row>
                </v-form>
                <div>
                    <v-text-field outlined value="yutubeid" v-model="youtubeid" label="Youtube Stream" :append-outer-icon="icons.save" @click="saveYouTubeId()"/>
                </div>
            </v-card-text>
            <v-card-actions>
                <BaseBtn  @click="checkCancel()">
                    <v-icon>{{icons.arrowleft}}</v-icon>
                    <span class="hidden-xs-only">Back</span>
                </BaseBtn>
                <v-spacer></v-spacer>
                <BaseBtn @click="cancel()" :disabled="!dirty">
                    <v-icon>{{icons.undo}}</v-icon>
                    <span class="hidden-xs-only">Reset</span>
                </BaseBtn>
                <v-spacer></v-spacer>
                <BaseBtn :loading="loading" :disabled="!(dirty)" @click="save()">Save</BaseBtn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
  import {
    mapState,
    mapActions
  } from 'vuex'
  import BaseBtn from "../BaseBtn";
  import isEqual from 'lodash/isEqual'
  export default {
    components: {BaseBtn},
    name: "OrgSocial",
    data() {
      return {
        loading:false,
        dirty:false,
        social:{},
        cellerror:false,
        cellerrormessage:undefined,
        validinfo:true,
        users:false,
        emailverified:false,
        imagedialog: false,
        activeimage: undefined,
        ibht: 70,
        youtubeid: undefined
      }
    },
    computed:{
      ...mapState(['icons','appdata','org','socialnetworks']),
      social_unchanged(){
        if(this.org && this.org.social) {
          return this.org.social
        } else{
          let f = {}
          this.socialnetworks.forEach(s=>{
            f[s.type]=undefined
          })
          return this.socialnetworks.map(m=>{return {[m.type]:''} })
        }
      }
    },
    watch:{
      org(n){
        if(!n){
          this.rookie = true;
          return
        }
        this.social = Object.assign({},this.org.social)
        this.rookie=false
      }
    },
    mounted() {
      this.cancel()
      this.$store.dispatch('removeNtfs',{code:'apporg'})
    },
    methods: {
      ...mapActions(['get', 'post']),
      async saveYouTubeId(){
        let data = {
          youtubeid:this.youtubeid
        }
        let v = this.post({path:'api/orgs/youtubelivestreamcode',body:data})
        return v
      },
      async save(){
        this.loading=true;
        let path = 'api/orgs/social'
        let body = {
          key:'social',
          value:this.social,
          app:'textappy'
        }
        let res = await this.post({path:path,body:body})
        console.log(res)
        this.loading=false
        if(res.error) {
          this.$store.commit('setSnackbar', {
            type: res.error.status,
            msg: res.error.message,
            timeout: 5000
          })
          return
        }
        this.$store.dispatch('putAppOrg',res)
        this.$store.commit('setSnackbar',{
          type: 'success',
          msg: (this.rookie)?'Thats it! Go add some contacts!':'Organization saved!',
          timeout:5000
        })
        this.setChange()
      },
      cancel(){
        this.social = Object.assign({},this.social_unchanged)
        this.dirty = false
      },
      checkCancel(){
        this.$router.history.go(-1)
      },
      setChange(){
        let a = Object.values(this.social)
        let b = Object.values(this.social_unchanged)
        let s = isEqual(a,b)
        this.dirty = !s
      },

    }
  }
</script>

<style scoped>

</style>